import React from 'react';
import ActionsTooltip from '../../../components/ActionsTooltip';
import AsyncSelect from '../../AsyncSelect';
import Button from '../../../components/Button';
import Checkbox from '@material-ui/core/Checkbox';
import { components } from 'react-select';
import CreateIcon from '@material-ui/icons/Create';
import DeleteIcon from '@material-ui/icons/DeleteForeverOutlined';
import Divider from '@material-ui/core/Divider';
import GeneralDialog from '../../GeneralDialog';
import generateId from '../../../utils/generateId';
import IconButton from '@material-ui/core/IconButton';
import InitialsBadge from '../../../components/InitialsBadge';
import ListItemText from '@material-ui/core/ListItemText';
import MenuItem from '@material-ui/core/MenuItem';
import Paper from '../../../components/layouts/Paper';
import SearchEngine from '../../../components/engine/SearchEngine';
import Select from '@material-ui/core/Select';
import SlimLineCard from '../../../components/containers/cards/SlimLineCard';
import styled from 'styled-components/macro';
import Text, { TextString } from '../../../components/Text';
import Tooltip from '@material-ui/core/Tooltip';
import useFetchWithCallbacks from '../../../hooks/useFetchWithCallbacks';
import useTranslations from '../../../hooks/useTranslations';

const cardCSS = `

  margin-bottom: 1rem;

  h2 {
    margin: 0;
    margin-left: 0.8rem;
    font-size: 18px;
  }

  svg {
    color: #c8c8c8;
  }

`;

const getUserLabel = u => {
  let alreadyAdmin = false;
  if (u.rolesData && u.rolesData.role !== 'end_user') {
    alreadyAdmin = true;
  }
  return {
    label: `${u.info.firstName} ${u.info.lastName}`,
    value: u.id,
    _id: generateAdminId(),
    alreadyAdmin: alreadyAdmin,
    firstName: u.info.firstName,
    email: u.info.email
  };
};

const generateAdminId = () => 'admin_' + generateId();

const FlexRow = styled.div`
  display: flex;
  justify-content: space-between;
  & > div {
    width: 33%;
    padding: 8px 0;
    padding-right: 12px;
    max-width: 50%;
    display: flex;
    align-items: center;
  }

  // & > div:nth-child(3) {
  //   width: 225px;
  // }

  & > div:nth-child(4) {
    flex: none;
    padding: 0;
    width: 52px;
  }
`;

const SaveWrapper = styled.div`
  padding: 24px 0;
`;

export const UserInfo = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 0.8rem;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  small {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

const TopContainer = styled.div`
  display: flex;
  margin-bottom: 2rem;
`;

const ButtonsContainer = styled.div`
  margin-left: auto;
`;

const DefaultAssigneeSelect = styled(Select)`
  background-color: #fff;
  border: 1px solid #bfc5d1;
  border-radius: 5px;
  box-sizing: border-box;
  font-size: 14px !important;
  font-weight: 400 !important;
  height: 30px;
  margin: 1rem 0;
  padding: 0.1em 1.3em 0.1em 0.8em;
  position: relative;
  &&:before,
  &&:after {
    border-bottom: !important;
    content: none;
  }
  &&:hover {
    border: 1px solid #000;
  }
  & > svg {
    color: #000 !important;
    right: 0.5em !important;
    top: 0 !important;
  }
`;

const Header = styled.h2`
  font-size: 18px;
  margin-top: 3.2rem;
  margin-bottom: 0;
`;

const ListDivider = styled(Divider)`
  && {
    margin-top: 3rem;
  }
`;

const DescriptionText = styled.div`
  margin-bottom: 1rem;
`;

const FormBuilderCollaborateView = props => {
  const t = useTranslations();

  return (
    <Paper
      theme="light"
      align="left"
      width={800}
      style={{ margin: '20px auto 0', width: 1060 }}
    >
      <TopContainer>
        <SearchEngine onSearch={props.onSearch} />
        <ButtonsContainer>
          <Button onClick={props.onAddNewAdminGroup} variant="outlined">
            {t('form-builder.admins.add_section_admin')}
          </Button>
          <Button onClick={props.onAddNewAdmin}>
            {t('form-builder.admins.add')}
          </Button>
        </ButtonsContainer>
      </TopContainer>
      <Header>{t('form-builder.admins.form_admins')}</Header>
      <DescriptionText>
        {t('form-builder.admins.form_admin_description_text')}
      </DescriptionText>
      {props.collaborators.map((a, i) => (
        <ActionsTooltip
          key={a._id}
          leaveDelay={0}
          buttons={[
            <Tooltip title="Edit">
              <IconButton size="small" onClick={() => props.onEdit(a)}>
                <CreateIcon />
              </IconButton>
            </Tooltip>,
            <Tooltip title="Delete" onClick={() => props.clickedDelete(a._id)}>
              <IconButton size="small">
                <DeleteIcon />
              </IconButton>
            </Tooltip>
          ]}
        >
          <SlimLineCard $rounded $css={cardCSS}>
            <span>
              <InitialsBadge firstName={a.firstName} lastName={a.lastName} />
            </span>
            <UserInfo>
              <b>{a.label}</b>
              <small>{a.email}</small>
            </UserInfo>
          </SlimLineCard>
        </ActionsTooltip>
      ))}
      {props.collaborators.length === 0 ? (
        <p>
          <em>
            <TextString content="form-builder.admins.no_admins" />
          </em>
        </p>
      ) : (
        ''
      )}
      {props.collaborators.length !== 0 &&
        props.eligibleForDefaultAdmin &&
        props.eligibleForDefaultAdmin.length > 0 && (
          <div style={{ marginTop: '2em' }}>
            <TextString content="form-builder.admins.default" />
            <div style={{ width: '50%' }}>
              <DefaultAssigneeSelect
                data-testid="formbuilder-collaborate-select-default-admin"
                value={props.defaultAssignee}
                renderValue={value => {
                  var matches = props.collaborators.filter(c => {
                    return (
                      value === c.value &&
                      (!c.groups || !c.groups.length || c.groups[0] === 'all')
                    );
                  });
                  if (matches.length) {
                    return matches[0].label;
                  }
                  return (
                    <TextString content="form-builder.admins.no_default_set" />
                  );
                }}
                disabled={!props.collaboratorsWithoutAGroup.length}
                displayEmpty
                fullWidth
                onChange={e => {
                  props.setChangedDefaultAssignee(true);
                  props.setDefaultAssignee(e.target.value);
                }}
                inputProps={{
                  'data-testid': 'select-default-admin'
                }}
                SelectDisplayProps={{
                  'data-testid': 'select-default-admin-div'
                }}
              >
                <MenuItem
                  value=""
                  key="default-assignee-empty"
                  data-testid="formbuilder-collaborate-default-assignee-empty"
                >
                  <TextString content="form-builder.admins.no_default_set" />
                </MenuItem>
                {props.eligibleForDefaultAdmin.map((oneCollaborator, i) => {
                  return (
                    <MenuItem
                      value={oneCollaborator.value}
                      key={'default-assignee-' + oneCollaborator.value}
                      data-testid={
                        'formbuilder-collaborate-default-assignee-' + i
                      }
                    >
                      {oneCollaborator.label}
                    </MenuItem>
                  );
                })}
              </DefaultAssigneeSelect>
            </div>
          </div>
        )}
      <Header>{t('form-builder.admins.view_only_admins')}</Header>
      <DescriptionText>
        {t('form-builder.admins.form_view_only_admin_description_text')}
      </DescriptionText>
      {props.viewOnlyCollaborators.map((a, i) => (
        <ActionsTooltip
          key={a._id}
          leaveDelay={0}
          buttons={[
            <Tooltip title="Edit">
              <IconButton size="small" onClick={() => props.onEdit(a)}>
                <CreateIcon />
              </IconButton>
            </Tooltip>,
            <Tooltip title="Delete" onClick={() => props.clickedDelete(a._id)}>
              <IconButton size="small">
                <DeleteIcon />
              </IconButton>
            </Tooltip>
          ]}
        >
          <SlimLineCard $rounded $css={cardCSS}>
            <span>
              <InitialsBadge firstName={a.firstName} lastName={a.lastName} />
            </span>
            <UserInfo>
              <b>{a.label}</b>
              <small>{a.email}</small>
            </UserInfo>
          </SlimLineCard>
        </ActionsTooltip>
      ))}
      <ListDivider variant="middle" />

      <Header>{t('form-builder.admins.section_admins')}</Header>
      <DescriptionText>
        {t('form-builder.admins.section_admins_description_text')}
      </DescriptionText>
      {props.sectionAdmins.map((a, i) => (
        <ActionsTooltip
          key={a._id}
          leaveDelay={0}
          buttons={[
            <Tooltip title="Edit">
              <IconButton
                size="small"
                onClick={() => props.onAdminGroupEdit(a)}
              >
                <CreateIcon />
              </IconButton>
            </Tooltip>,
            <Tooltip
              title="Delete"
              onClick={() => props.clickedDeleteOnAdminGroup(a)}
            >
              <IconButton size="small">
                <DeleteIcon />
              </IconButton>
            </Tooltip>
          ]}
        >
          <SlimLineCard $rounded $css={cardCSS}>
            <span>
              <InitialsBadge firstName={props.getAdminGroupName(a.bucketId)} />
            </span>
            <UserInfo>
              <b>{props.getAdminGroupName(a.bucketId)}</b>
              <small>
                {t('form-builder.admins.section_admin_user_count', {
                  count: a.groupSize
                })}
              </small>
            </UserInfo>
          </SlimLineCard>
        </ActionsTooltip>
      ))}
      {props.sectionAdmins.length === 0 ? (
        <p>
          <em>
            <TextString content="form-builder.admins.no_admins" />
          </em>
        </p>
      ) : (
        ''
      )}

      <GeneralDialog
        open={props.askingToConfirm}
        handleClose={() => {
          props.setAskingToConfirm(false);
          props.setSubmitting(false);
        }}
        handleConfirm={() => {
          props.setAskingToConfirm(false);
          props.clickedSaveCollaborators(true);
        }}
        title="dialog.title.areYouSure"
        content="form-builder.add_collaborators.warning"
      />
    </Paper>
  );
};

export default FormBuilderCollaborateView;
